import React from 'react';
import PropTypes from 'prop-types';
import {NeuroMessage, Tooltip} from '../../../neuro-guide/components';

const ChartHeader = ({ config }) => {
  return (
    <>
      { config?.header.isEnabled &&
        <div className="chartHeader">
          <NeuroMessage shouldHideIfNotFound={true} id={`${config.chartKey}.header`} />
          <Tooltip messageId={`${config.chartKey}.tooltip`} />
        </div>
      }
    </>
  );
};

ChartHeader.propTypes = {
  config: PropTypes.shape({
    header: PropTypes.shape({
      isEnabled: PropTypes.bool
    }),
    chartKey: PropTypes.string
  })
};

export default ChartHeader;